import { css, SerializedStyles } from '@emotion/react';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { ButtonAppearanceType, ButtonSizeType } from 'src/ui/components/button/icon-only/types';

export const buildBtnDisabledOrLoading = (disabled?: boolean, isLoading?: boolean): SerializedStyles | null => {
    if (disabled === true) {
        return css`
            cursor: not-allowed;
            opacity: 0.4;
            pointer-events: none;
        `;
    }

    if (isLoading === true) {
        return css`
            pointer-events: none;
        `;
    }

    return null;
};

export const appearanceStyle = (
    theme: EmotionTheme,
    appearance: ButtonAppearanceType,
    variant: DefaultComponentVariantType | null = null
): SerializedStyles => {
    if (variant === DefaultComponentVariantType.TERTIARY) {
        return {
            primary: css`
                background: ${theme.star.button.primary.colors.bgPrimary};
                color: ${theme.star.button.primary.colors.txtPrimary};
                &:hover,
                &:active {
                    &::after {
                        background: ${theme.star.button.primary.colors.bgSecondary};
                    }
                }
            `,
            secondary: css`
                background: ${theme.star.unified.button.secondary.colors.bgPrimary};
                color: ${theme.star.unified.button.secondary.colors.txtPrimary};
                &:hover,
                &:active {
                    &::after {
                        background: ${theme.star.unified.button.secondary.colors.bgSecondary};
                    }
                }
            `,
            'secondary-dark': css`
                background: ${theme.star.button.secondaryDark.colors.bgPrimary};
                color: ${theme.star.button.secondaryDark.colors.txtPrimary};
                &:hover,
                &:active {
                    &::after {
                        background: ${theme.star.button.secondaryDark.colors.bgSecondary};
                    }
                }
            `,
            danger: css`
                background: ${theme.star.button.danger.colors.bgPrimary};
                color: ${theme.star.button.danger.colors.txtPrimary};
                &:hover,
                &:active {
                    &::after {
                        background: ${theme.star.button.danger.colors.bgSecondary};
                    }
                }
            `,
        }[appearance];
    }

    return {
        primary: css`
            background: ${theme.star.button.primary.colors.bgPrimary};
            color: ${theme.star.button.primary.colors.txtPrimary};
            &:hover,
            &:active {
                &::after {
                    background: ${theme.star.button.primary.colors.bgSecondary};
                }
            }
        `,
        secondary: css`
            background: ${theme.star.button.secondary.colors.bgPrimary};
            color: ${theme.star.button.secondary.colors.txtPrimary};
            &:hover,
            &:active {
                &::after {
                    background: ${theme.star.button.secondary.colors.bgSecondary};
                }
            }
        `,
        'secondary-dark': css`
            background: ${theme.star.button.secondaryDark.colors.bgPrimary};
            color: ${theme.star.button.secondaryDark.colors.txtPrimary};
            &:hover,
            &:active {
                &::after {
                    background: ${theme.star.button.secondaryDark.colors.bgSecondary};
                }
            }
        `,
        danger: css`
            background: ${theme.star.button.danger.colors.bgPrimary};
            color: ${theme.star.button.danger.colors.txtPrimary};
            &:hover,
            &:active {
                &::after {
                    background: ${theme.star.button.danger.colors.bgSecondary};
                }
            }
        `,
    }[appearance];
};

export const sizeStyles = (
    theme: EmotionTheme,
    size: ButtonSizeType,
    variant: DefaultComponentVariantType | null = null
): SerializedStyles => {
    if (variant === DefaultComponentVariantType.TERTIARY) {
        return {
            'x-small': css`
                border-radius: ${theme.star.radius.small};
                font-size: ${theme.star.button.common.typography.fontSizePrimary};
                line-height: ${theme.star.button.common.typography.lineHeightPrimary};
                padding: 0 8px;
                height: 24px;
            `,
            small: css`
                border-radius: ${theme.star.radius.small};
                font-size: ${theme.star.button.common.typography.fontSizeSecondary};
                line-height: ${theme.star.button.common.typography.lineHeightSecondary};
                padding: 0 16px;
                height: 32px;
            `,
            medium: css`
                border-radius: ${theme.star.radius.small};
                font-size: ${theme.star.button.common.typography.fontSizeTertiary};
                line-height: ${theme.star.button.common.typography.lineHeightTertiary};
                padding: 0 24px;
                height: 44px;
            `,
            large: css`
                border-radius: ${theme.star.radius.small};
                font-size: ${theme.star.button.common.typography.fontSizeTertiary};
                line-height: ${theme.star.button.common.typography.lineHeightTertiary};
                padding: 0 24px;
            `,
        }[size];
    }
    return {
        'x-small': css`
            border-radius: ${theme.star.button.common.radiusPrimary};
            font-size: ${theme.star.button.common.typography.fontSizePrimary};
            line-height: ${theme.star.button.common.typography.lineHeightPrimary};
            padding: 4px 8px;
        `,
        small: css`
            border-radius: ${theme.star.button.common.radiusSecondary};
            font-size: ${theme.star.button.common.typography.fontSizePrimary};
            line-height: ${theme.star.button.common.typography.lineHeightPrimary};
            padding: 8px 12px;
        `,
        medium: css`
            border-radius: ${theme.star.button.common.radiusSecondary};
            font-size: ${theme.star.button.common.typography.fontSizeSecondary};
            line-height: ${theme.star.button.common.typography.lineHeightSecondary};
            padding: 12px 16px;
        `,
        large: css`
            border-radius: ${theme.star.button.common.radiusSecondary};
            font-size: ${theme.star.button.common.typography.fontSizeTertiary};
            line-height: ${theme.star.button.common.typography.lineHeightSecondary};
            padding: 16px 20px;
        `,
    }[size];
};
